// TODO: rewrite enums to const or vice versa
export enum MethodsEnum {
  GET = 'GET',
  PUT = 'PUT',
  POST = 'POST',
  DELETE = 'DELETE',
}

export enum ReviewTypeEnum {
  location = 'location',
  point = 'point',
}

export enum MapLayersEnum {
  googleMaps = 'Google Maps',
  googleMapsSatellite = 'Google Maps (Satellite)',
}
